module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="select-all">\n    <label><input type="checkbox" /> Select All</label>\n</div>\n<ul class="toc-tree with-checkboxes" id="toc-tree-recentdocs" role="tree" aria-labelledby="select-recentdocs"></ul>\n';
}
return __p;
};
